import React, { useState } from 'react';
import HelmetSEO from './HelmetSEO';
import HeaderNav from './HeaderNav';
import FooterNav from './FooterNav';
import MainContent from './MainContent';
import Sidebar from './Sidebar';
import { useTabNavigation } from '../hooks/useTabNavigation';

/**
 * Componente Layout principal de la documentación con Sidebar e interfaz 100% responsive
 */
export default function DocsLayout() {
  const { activeTab, handleTabChange } = useTabNavigation('desarrolladores');
  const [activeSection, setActiveSection] = useState('dev-overview');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="docs-app-container">
      <HelmetSEO activeTab={activeTab} />
      <Sidebar 
        activeTab={activeTab} 
        activeSection={activeSection} 
        onSelectSection={setActiveSection} 
        mobileMenuOpen={mobileMenuOpen}
        onCloseMobileMenu={() => setMobileMenuOpen(false)}
      />
      <div className="docs-main-wrapper">
        <HeaderNav 
          activeTab={activeTab} 
          setActiveTab={handleTabChange} 
          onToggleMobileMenu={() => setMobileMenuOpen(!mobileMenuOpen)}
        />
        <MainContent activeTab={activeTab} />
        <FooterNav />
      </div>
    </div>
  );
}
